<script>
  import { dev } from "$app/environment";
  import { page } from "$app/stores";
  import { onMount } from "svelte";
  import { reportError } from "@/utils";
  import NoIndexHead from "@/components/atoms/NoIndex.svelte";

  const handleBrowserError = () => {
    if (!dev) {
      reportError(
        new Error(
          $page.error?.stack ||
            $page.error?.message ||
            JSON.stringify($page.error)
        )
      );
    }
  };
  onMount(() => {
    handleBrowserError();
  });
</script>

<svelte:head>
  <title>{$page.status}</title>
</svelte:head>
<NoIndexHead />

<section
  class="bg-error text-white min-h-screen flex flex-col justify-center items-center p-md"
  data-cy="error-screen"
>
  <h1 class="font-extrabold">{$page.status}</h1>

  <p class="text-center">{$page.error && $page.error.message}</p>

  {#if dev && $page.error && $page.error.stack && $page.status !== 404}
    <pre class="w-full whitespace-pre-wrap break-words">{$page.error &&
        $page.error.stack}</pre>
  {/if}
</section>

<style>
  h1 {
    font-size: 4.8em;
  }

  p {
    font-size: 1.5em;
    margin: 1em auto;
  }

  @media (min-width: 480px) {
    h1 {
      font-size: 4em;
    }
  }
</style>
